import React, { useState, useEffect } from "react";
import Navbar from "../component/Dasboard/Navbar";
import Heading from "../component/Dasboard/Heading";
import Jumbutron from "../component/Dasboard/Jumbutron";
import { url } from "../api/api";
import axios from "axios";
import Mobilenav from "../component/Mobiledashboard/Mobilenav";
import Mobileheader from "../component/Mobiledashboard/Mobileheader";
import Mobilejumbotron from "../component/Mobiledashboard/Mobilejumbotron";

import Mobilecryptolisting from "../component/Mobiledashboard/Mobilecryptolisting";
import CryptoChart from "../component/Dasboard/CryptoChart";

const Dashboard = () => {
  const [balance, setBalance] = useState([]);

  const totalFinalBalance = balance.reduce((accumulator, transaction) => {
    return accumulator + transaction.finalBalance;
  }, 0);

  const formattedBalance = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(totalFinalBalance);

  console.log(formattedBalance);

  useEffect(() => {
    // Fetch data from backend

    const userid = JSON.parse(localStorage.getItem("userdata"));

    axios
      .get(`${url}/funding/fetchbalance`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userid.token}`,
        },
      })
      .then((response) => {
        setBalance(response.data.balance);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, []);

  return (
    <>
      <div className="md:h-[800px] bg-[#00001A] hidden md:block">
        <Navbar />
        <Heading />
        <Jumbutron totalbalance={formattedBalance} />
      </div>

      <div className="h-[1000px] bg-[#00001A] block md:hidden  pt-[50px] px-6">
        <Mobileheader />
        <Mobilejumbotron totalbalance={formattedBalance} />
        <Mobilenav />
        <Mobilecryptolisting />
        <div className="px-4 py-4">
          <CryptoChart />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
